import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import ContextComponent from "../../../../AppContext";
import Utils from "../../../../Utils";

const SectionBreadcrumbs = ({ props }) => {
    let navigate = useNavigate();
    let siteId = props.siteid;
    let sectionId = props.sectionid;
    let projectId = props?.projectid;
    let currentPath = props?.currPath;
    let [canRender, setCanRender] = useState(false);
    let [siteName, setSiteName] = useState("");
    let [sectionName, setSectionName] = useState("");
    let [sectionRecord, setSectionRecord] = useState({});

    let { setCanRedirectToLogin } = useContext(ContextComponent);

    const success = (res) => {
        let data = res.data;
        setSectionRecord(data);
        data.forEach((s) => {
            if (s.id === sectionId) {
                let siteName = s.site.toUpperCase();
                let sectionName = s.name.toUpperCase();
                setSiteName(siteName);
                setSectionName(sectionName);
                setCanRender(true);
            }
        });
    };

    const fail = (err) => {
        err?.message?.length && console.log(err);
        if (err?.redirect) {
            setCanRedirectToLogin(true);
        }
    };

    const loadFreshSections = () => {
        Utils.getAllSections({ siteId: siteId }).then(success, fail);
    };

    useEffect(() => {
        loadFreshSections();
    }, []);

    const navgiatToSectionsPage = (e) => {
        e.preventDefault();
        const sectionPath = Utils.APP_URLS.SECTION_PAGE
        .replace(":siteid", siteId)
        .replace(":sectionid", sectionId);

        const sitePagePath = Utils.APP_URLS.SITE_PAGE.replace(":siteid", siteId);
            
        const projectSitePath = Utils.APP_URLS.PROJECT_SITE_PAGE
          .replace(":projectid", projectId)
          .replace(":siteid", siteId);
            
        const targetPath = currentPath === sectionPath ? sitePagePath : projectSitePath;
        navigate(targetPath);
    };

    return (
        <>
            {canRender && (
                <div className="indi-body-breadcrumbs-wrapper d-flex w-100">
                    <span className="indi-breadcrumb-item indi-breadcrumb-link" onClick={navgiatToSectionsPage}>{siteName}</span>
                    <span className="indi-breadcrumb-item indi-breadcrumb-divider">{"/"} </span>
                    <span className="indi-breadcrumb-item">{sectionName}</span>
                </div>
            )}
        </>
    );
};

export default SectionBreadcrumbs;